/**
 * DataObject.ts
 */
export class DataObject {
    constructor(object = null) {
        this.object = (object != null) ? object : {};
    }
    containsKey(key) {
        return this.object[key] != null;
    }
    getBool(key) {
        return this.object[key];
    }
    getBoolArray(key) {
        return this.object[key];
    }
    getNumber(key) {
        return this.object[key];
    }
    getNumberArray(key) {
        return this.object[key];
    }
    getStringArray(key) {
        return this.object[key];
    }
    getDataObject(key) {
        let dataObject = null;
        if (this.containsKey(key)) {
            let data = this.object[key];
            if (data instanceof DataObject) {
                dataObject = data;
            }
            else {
                dataObject = new DataObject(data);
            }
        }
        return dataObject;
    }
    getDataArray(key = null) {
        let array = key ? this.object[key] : this.object;
        let data = array;
        if (array && array.length > 0) {
            let firstData = array[0];
            if (firstData instanceof DataObject) {
                data = array;
            }
            else {
                data = [];
                for (let i = 0; i < array.length; i++) {
                    data.push(new DataObject(array[i]));
                }
            }
        }
        return data;
    }
    getString(key) {
        return this.object[key];
    }
    putBoolean(key, value) {
        this.object[key] = value;
    }
    putBooleanArray(key, value) {
        this.object[key] = value;
    }
    putNumber(key, value) {
        this.object[key] = value;
    }
    putNumberArray(key, value) {
        this.object[key] = value;
    }
    putDataObject(key, value) {
        this.object[key] = value;
    }
    putPlainObject(key, value) {
        this.object[key] = value;
    }
    putDataArray(key, value) {
        let array = [];
        for (let i = 0; i < value?.length; i++) {
            array.push(value[i].toObject());
        }
        this.object[key] = array;
    }
    putString(key, value) {
        this.object[key] = value;
    }
    putStringArray(key, value) {
        this.object[key] = value;
    }
    toObject() {
        return this.object;
    }
    getDump() {
        return JSON.stringify(this.object, null, 4);
    }
}
//# sourceMappingURL=DataObject.js.map